import INear from './INear'
import Axios from 'axios'
import { isString, isArray } from 'util'

/**
 * 临近分析
 * 后台分析模式
 */
export default class IServerOperation extends INear {
    // 请求参数
    params = {}

    /**
     * 构造函数
     * @param {*} serviceUrl 必须 服务地址
     * @param {*} proxyUrl 非必须
     */
    constructor(serviceUrl, proxyUrl = '') {
        super()

        // url 参数
        this.serviceUrl = serviceUrl
        this.proxyUrl = proxyUrl

        // 服务类型
        this._type = !serviceUrl.endsWith('/overlapservice') ? 'WPS' : 'SAS'
    }

    /**
     * 发送请求
     * @override
     */
    async _process(...rest) {
        return IServerOperation.PROCESSES[this._type].call(this, ...rest)
    }

    /**
     * 构建请求体
     */
    absBuildExecute(fc, ...rest) {
        throw 'please implement this methods'
    }

    // 请求方法体（wps和sas）
    static PROCESSES = {
        async SAS(fc, ...rest) {
            const execute = this.absBuildExecute(fc, ...rest)

            return Axios.post(
                this.proxyUrl + this.serviceUrl + '?1=1',
                execute,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    params: {
                        VERSION: '1.0.0',
                        SERVICE: 'OverlapService',
                        ...this.params
                    }
                }
            ).then(({ data }) => {
                try {
                    return data.results[0].features.map(f => {
                        return {
                            type: 'Feature',
                            properties: f.attributes,
                            geometry: f.geometry
                        }
                    })
                } catch (error) {
                    throw '临近分析失败！'
                }
            })
        },
        async WPS(...rest) {
            // 构建请求体
            const args = this.absBuildExecute(...rest)
            let execute = require(`../tmpls/${this.operation}.js`).default
            for (let i = 0; i < args.length; i++) {
                const param = args[i]
                execute = execute.replace(`{INPUT${i + 1}}`, param)
            }

            const url =
                this.proxyUrl +
                this.serviceUrl +
                (this.serviceUrl.endsWith('/Execute') ? '' : '/Execute')

            return Axios.post(url, execute, {
                headers: { 'Content-Type': 'text/xml' }
            }).then(({ data }) => {
                if (!data || data === '' || data.includes('ServiceException')) {
                    throw '临近分析失败！'
                }
                try {
                    return IServerOperation.GML2GeoJson(data)
                } catch (error) {
                    console.error('wps error:', error)
                    throw '临近分析失败！'
                }
            })
        }
    }

    /**
     * 数据转换
     * @param {*} geojson
     */
    static GeoJson2GML(geojson) {
        if (isArray(geojson)) {
            geojson = {
                type: 'FeatureCollection',
                features: geojson
            }
        }
        return new GeoGlobe.Format.GML().write(
            new GeoGlobe.Format.GeoJSON().read(geojson)
        )
    }

    /**
     * 数据转换
     * @param {*} gmlStr
     */
    static GML2GeoJson(gmlStr) {
        let geojson = new GeoGlobe.Format.GeoJSON().write(
            new GeoGlobe.Format.GML().read(gmlStr)
        )
        if (isString(geojson)) {
            geojson = JSON.parse(geojson)
        }
        return geojson
    }
}
